import * as React from "react";
import { VisuallyHiddenInput } from "./InputFile";
import { Button, CircularProgress } from "@mui/material";
import { CheckCircleRounded, CloudUploadRounded } from "@mui/icons-material";
import { useState } from "react";

const FileField = (props) => {
  const [parsing, setParsing] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setParsing(true);
      props.setSelectedFile(file);

      setTimeout(() => {
        props.onAutoSubmit(file);
        setParsing(false);
      }, 1500);
    }
  };

  return (
    <>
      <Button
        fullWidth
        color="black"
        component="label"
        htmlFor="file-input"
        sx={{
          border: "3px dashed var(--borderColor)",
          backgroundColor: "var(--listRow)",
          borderRadius: "var(--borderRadius)",
          height: "11.2rem",
          display: "flex",
          justifyContent: "center",
          padding: "0 1rem",
        }}
      >
        {" "}
        <div
          className={`file-iconography ${props.selectedFile && !parsing ? "file" : ""}`}
        >
          {parsing ? (
            <>
              <CircularProgress color="inherit" size={30} />
              <p className="mb-0">Parsing CSV...</p>
            </>
          ) : props.selectedFile ? (
            <>
              <CheckCircleRounded color="green" fontSize="large" />
              <p className="mb-0">Your new cards have been added below</p>
            </>
          ) : (
            <>
              <CloudUploadRounded color="iconGray" fontSize="large" />
              <p className="mb-0">Upload CSV here</p>
            </>
          )}
        </div>
      </Button>

      <VisuallyHiddenInput
        type="file"
        id="file-input"
        onChange={handleFileChange}
        accept=".csv"
      />
    </>
  );
};

export default FileField;
